'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _VstToast = require('./VstToast');

var _VstToast2 = _interopRequireDefault(_VstToast);

var _customEvent = require('custom-event');

var _customEvent2 = _interopRequireDefault(_customEvent);

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toastMethods = function toastMethods() {
  var _toasts = [];

  var defaultOptions = function defaultOptions() {
    return {
      id: 'vst-toast-' + Math.random(),
      timeout: 5000,
      type: 'info',
      horizontalPosition: 'center',
      verticalPosition: 'top'
    };
  };

  var renderToasts = function renderToasts() {
    var event = new _customEvent2.default('_vstui_add_toast', {});
    document.dispatchEvent(event);
  };

  var VstToastDom = function (_Component) {
    _inherits(VstToastDom, _Component);

    function VstToastDom() {
      _classCallCheck(this, VstToastDom);

      var _this = _possibleConstructorReturn(this, (VstToastDom.__proto__ || Object.getPrototypeOf(VstToastDom)).call(this));

      _this.state = {};

      _this.addToast = _this.addToast.bind(_this);
      return _this;
    }

    _createClass(VstToastDom, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('_vstui_add_toast', this.addToast);
      }
    }, {
      key: 'render',
      value: function render() {
        // We need first toast options to understand where to position our toasts
        var firstToastOptions = _toasts.length > 0 ? _toasts[0] : {};
        return _react2.default.createElement(
          'span',
          { className: 'vst-toast-dom' },
          _react2.default.createElement(
            'div',
            null,
            this.renderToastGroup('left', 'top'),
            this.renderToastGroup('center', 'top'),
            this.renderToastGroup('right', 'top')
          ),
          _react2.default.createElement(
            'div',
            null,
            this.renderToastGroup('left', 'bottom'),
            this.renderToastGroup('center', 'bottom'),
            this.renderToastGroup('right', 'bottom')
          )
        );
      }
    }, {
      key: 'addToast',
      value: function addToast() {
        this.forceUpdate();
      }
    }, {
      key: 'filterToasts',
      value: function filterToasts(horizontal, vertical) {
        return _toasts.filter(function (toast) {
          return toast.horizontalPosition === horizontal && toast.verticalPosition === vertical;
        });
      }
    }, {
      key: 'renderToastGroup',
      value: function renderToastGroup(horizontal, vertical) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactAddonsTransitionGroup2.default,
            null,
            this.filterToasts(horizontal, vertical).map(function (toast) {
              return _react2.default.createElement(_VstToast2.default, _extends({
                key: 'vst-toast-portal-item-' + toast.id
              }, toast));
            })
          )
        );
      }
    }]);

    return VstToastDom;
  }(_react.Component);

  try {
    document.addEventListener('DOMContentLoaded', function () {
      try {
        var node = document.createElement('div');
        node.class = 'vst-toast-container-portal';
        document.body.appendChild(node);

        _reactDom2.default.render(_react2.default.createElement(VstToastDom, null), node);
      } catch (e) {
        // Toats won't work, but any app still will in < ie9
      }
    });
  } catch (e) {
    // document is not defined
  }

  var dismiss = function dismiss(id) {
    _toasts = _toasts.filter(function (toast) {
      return toast.id !== id;
    });
    renderToasts();
  };

  var dismissAll = function dismissAll() {
    _toasts = [];
    renderToasts();
  };

  var notify = function notify(description) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var opts = void 0;
    if (typeof description === 'string') {
      opts = Object.assign({}, defaultOptions(), { description: description }, options);
    } else {
      opts = Object.assign({}, defaultOptions(), description);
      opts.originalOnDismiss = opts.onDismiss;
    }
    opts.onDismiss = function () {
      if (opts.originalOnDismiss) {
        opts.originalOnDismiss();
      }
      dismiss(opts.id);
    };
    _toasts.push(_extends({}, opts));
    renderToasts();
  };

  return {
    notify: notify, dismiss: dismiss, dismissAll: dismissAll
  };
};

exports.default = toastMethods();


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstToastUtils.js
 **/